import React from 'react';
import { makeStyles } from '@material-ui/core';

import { Grid, Typography } from '@ha/dsl';

const useStyles = makeStyles(theme => ({
  label: {
    width: '100%',
  },
  countWrapper: {
    background: theme.palette.grey[100],
    borderRadius: '30px',
  },
  countLabel: {
    color: theme.palette.grey[600],
    padding: '1px 8px',
  },
}));

interface Props {
  title: string;
  count?: number;
}

const CommonCheckboxTitleWithCount: React.FC<Props> = ({ title, count }) => {
  const classes = useStyles();

  return (
    <Grid
      container
      className={classes.label}
      justify="space-between"
      alignItems="center"
      component="span"
    >
      <Grid item component="span">
        {title}
      </Grid>
      <Grid item component="span" className={classes.countWrapper}>
        <Typography.HelperText
          fontWeight="bold"
          component="span"
          className={classes.countLabel}
        >
          {count || 0}
        </Typography.HelperText>
      </Grid>
    </Grid>
  );
};

export default CommonCheckboxTitleWithCount;
